// removed by extract-text-webpack-plugin
module.exports = {"ConsentContainerOverlay":"GdprCookieConsent-ConsentContainerOverlay","ConsentContainer":"GdprCookieConsent-ConsentContainer","MessageContainer":"GdprCookieConsent-MessageContainer","AcceptButtonContainer":"GdprCookieConsent-AcceptButtonContainer","AcceptButton":"GdprCookieConsent-AcceptButton","Message":"GdprCookieConsent-Message","MessageLink":"GdprCookieConsent-MessageLink"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/rlink-cookies/GdprCookieConsent.less
// module id = 134
// module chunks = 0